const baseURL = '';
const url = '';

export { baseURL, url };
